<template>
	<div>
		<div class="sense-main">
			<div class="sense-breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				    <el-breadcrumb-item :to="{ path: '/myPackage' }" @click.native="backToPage">{{packageName}}</el-breadcrumb-item>
				    <el-breadcrumb-item>使用记录</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="sense-search sense-search-more clearfix">
				<el-row>
					<el-form>								
						<el-col :span="7" :offset="14">
							<el-form-item label="账号/授权码" label-width="120px">
								<el-input size="medium" v-model.trim="searchObj.account" maxlength="64"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="3" class="text-right">
							<el-button class="search-btn" size="medium" @click="emptySearch">清空</el-button>
							<el-button class="search-btn" size="medium" type="primary" @click="searchRecordList">搜索</el-button>
						</el-col>									
					</el-form>
				</el-row>
			</div>			
			<div class="sense-table-list sense-table-ellipsis">
				<el-table :data="recordListData">														
					<el-table-column prop="account" label="账号/授权码" min-width="20%" show-overflow-tooltip></el-table-column>
					<el-table-column :formatter="productNameFormatter" label="产品名称" min-width="18%" show-overflow-tooltip></el-table-column>	
					<el-table-column :formatter="licenseIdFormatter" label="许可ID" min-width="16%" show-overflow-tooltip></el-table-column>	
					<el-table-column :formatter="licenseFormFormatter" label="许可形式" min-width="10%"></el-table-column>
					<el-table-column :formatter="packageTypeFormatter" label="套餐类型" min-width="10%"></el-table-column>
					<el-table-column prop="deductCount" label="扣减数量" min-width="10%"></el-table-column>
					<el-table-column prop="createAt" label="使用时间" min-width="16%"></el-table-column>		
				</el-table>
			</div>
			<div class="sense-table-pager" v-if="total>0">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10,20,30]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<div class="all-dialog">
			
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			return {
				assetGuid: '',
				packageName: '',
				recordListData: [],  //行为日志列表数组
				currentPage: 1,  //当前页
				pageSize: 10,  //每页条数
				total: 0,  //数据总数
				searchObj: {
					account: ''
				}	
			}
		},
		methods: {
			getRecordList() {					
				let url = '/package/asset/record.do';
				let param = {
					assetGuid: this.assetGuid,
					account: this.searchObj.account,
				};
				param.currentPage = this.currentPage;
				param.pageSize = this.pageSize;

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.recordListData = response.data.rows;
						this.total = response.data.records;
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});									
			},
			//产品名称 formatter
			productNameFormatter(row, index) {
				if (row.productName) {
					return row.productName;
				} else {
					return '--';
				};
			},
			//许可ID formatter
			licenseIdFormatter(row, index) {
				if (row.licenseId) {
					return row.licenseId;
				} else {
					return '--';
				};
			},
			//许可形式 formatter
			licenseFormFormatter(row, index) {
				switch(row.licenseForm) {
					case 1:
						return '云锁';
						break;
					case 2:
						return '软锁';
						break;
				};
			},
			//套餐类型 formatter
			packageTypeFormatter(row, index) {
				switch(row.packageType) {
					case 1:
						return '许可套餐';
						break;
					case 2:
						return '更新次数套餐';
						break;
					case 3:
						return '硬件锁套餐';
						break;
				};
			},
			backToPage() {
				sessionStorage.setItem('isFirst', 1);
			},
			//搜索
			searchRecordList() {
				this.currentPage = 1;
				this.getRecordList();
			},
			//清空
			emptySearch() {
				this.searchObj.account = '';
				this.currentPage = 1;
				this.getRecordList();
			},	
			//切换每页显示条数
			handleSizeChange(val) {
				this.pageSize = val;
				this.getRecordList();
			},
			//切换当前页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getRecordList();
			},
		},
		mounted() {
			this.assetGuid = this.$route.query.assetGuid;
			this.packageName = this.$route.query.packageName;
			this.getRecordList();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// PackageRecord.vue?548a83d8